export default __webpack_public_path__ + "static/mypet-a8b3c357ab87f92e92a0aa1385fba29f.png";